import React from "react";
import { Col, Row } from "antd";

export const GutteredRow = ({ children }) => (
  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>{children}</Row>
);

export const DynamicCol = ({ children }) => (
  <Col xs={24} sm={24} md={11} lg={11} xl={11}>
    {children}
  </Col>
);

export const ResponsiveCol = ({ children }) => (
  <Col sm={24} lg={12}>
    {children}
  </Col>
);
